module.exports = new __parcel__URL__("product_1.e1f2645a.png").toString();